import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class MandateAuthStatusService {

    private mandateAuthorizationStatus = new BehaviorSubject<string>("Undefined");
    currentMandateAuthorizationStatus = this.mandateAuthorizationStatus.asObservable();

    constructor () { }

    changeMandateAuthorizationStatus(status: string) {
        this.mandateAuthorizationStatus.next(status);
    }

}